export const setNoFocus = (props, enabled = false) => enabled ? {
  tabIndex: -1,
  onMouseDown: e => {
    e.preventDefault();
    props?.onMouseDown?.(e);
  },
  onKeyUp: e => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
    }
    props?.onKeyUp?.(e);
  }
} : {};